import styled from "styled-components";

export const Switch = ({isChecked, onChange}) => {
    return (
        <StyledSwitch>
            <div />
            <input onChange={onChange} checked={isChecked} hidden type='checkbox'/>
        </StyledSwitch>
    )
}

const StyledSwitch = styled.label`
    display: block;
    background: ${({theme}) => theme.colors.mutedForeground};
    height: 18px;
    width: 32px;
    border-radius: ${({theme}) => theme.cornerRadius.md};
    padding: 2px;
    cursor: pointer;
    transition-duration: 220ms;
    
    div
    {
        
        background: ${({theme}) => theme.colors.neutralPrimaryBackground};
        width: 14px;
        height: 14px;
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        transform: translateX(0%);
        transition-duration: 150ms;
    }

    &:has(input:checked)
    {
        background: ${({theme}) => theme.colors.neutralSecondaryForeground};

        div
        {
            transform: translateX(100%);
        }
    }
`